import { render } from "./ProjectContactsViewCard.vue?vue&type=template&id=f4c3e70a"
import script from "./ProjectContactsViewCard.vue?vue&type=script&lang=js"
export * from "./ProjectContactsViewCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__